import { Modal as AntdModal, ModalProps as AntdModalProps } from "antd";
import { CMP_PREFIX } from "@/base/constant";

export interface ModalProps extends AntdModalProps {}

export const modalPrefixCls = `${CMP_PREFIX}-modal`;

export const Modal = ({ ...props }: ModalProps) => {
  return <AntdModal {...props} />;
};
